// Define cookie functions globally so they can be reused
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    encodeURIComponent(JSON.stringify(value)) +
    expires +
    "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length)));
      } catch (e) {
        console.error("Error parsing cookie:", e);
        return null;
      }
    }
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

// Main logic scoped to each .ctm-unique-banner
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ctm-unique-banner").forEach((sectionElement) => {
    // Initialize from cookies
    function initializeFromCookie() {
      const selections = getCookie("car_selections");
      if (selections) {
        const modelElement = sectionElement.querySelector(".selected-model");
        const yearElement = sectionElement.querySelector(".selected-year");
        const typeElement = sectionElement.querySelector(".selected-type");
        const categoryElement =
          sectionElement.querySelector(".selected-category");

        if (selections.model && modelElement) {
          modelElement.setAttribute(
            "data-selected-model-number",
            selections.model_number
          );
          modelElement.innerHTML = selections.model;
          filterYears(selections.model);
        }
        if (selections.year && yearElement) {
          yearElement.innerHTML = selections.year;
        } else if (selections.model) {
          setFirstAvailableYear(selections.model);
        }
        if (selections.type && typeElement) {
          typeElement.innerHTML = selections.type;
          if (
            selections.model &&
            (selections.year || yearElement.innerHTML !== "Select Year")
          ) {
            updateButtonHref();
          }
        }
        if (selections.category && categoryElement) {
          categoryElement.innerHTML = selections.category;
          if (
            selections.model &&
            (selections.year || yearElement.innerHTML !== "Select Year")
          ) {
            updateButtonHref();
          }
        }
      }
      updateButtonState();
    }

    // Filter years based on selected model
    function filterYears(selectedModel) {
      const years = sectionElement.querySelectorAll(".years .year");
      years.forEach((year) => {
        year.style.display =
          year.getAttribute("data-model") === selectedModel ? "block" : "none";
      });
    }

    // Set the first available year if none is selected
    function setFirstAvailableYear(selectedModel) {
      const years = sectionElement.querySelectorAll(".years .year");
      let firstYear = null;
      years.forEach((year) => {
        if (
          year.getAttribute("data-model") === selectedModel &&
          year.style.display !== "none"
        ) {
          if (!firstYear) {
            firstYear = year;
            sectionElement.querySelector(".selected-year").innerHTML =
              firstYear.innerHTML; // Use first available year
            updateCookie("year", firstYear.innerHTML);
            const currentSelections = getCookie("car_selections") || {};
            if (currentSelections.category) {
              updateButtonHref();
            }
          }
        }
      });
      updateButtonState();
    }

    // Toggle dropdown visibility
    function toggleDropdown(dropdownClass) {
      const dropdown = sectionElement.querySelector(dropdownClass);
      if (!dropdown) return; // Guard against null
      const selectElement = dropdown.closest(".custom-select");
      const isOpen = dropdown.classList.contains("open");

      sectionElement
        .querySelectorAll(".models, .years, .categories, .types")
        .forEach((el) => {
          el.classList.remove("open");
          el.closest(".custom-select").classList.remove("active");
        });

      if (!isOpen) {
        dropdown.classList.add("open");
        selectElement.classList.add("active");
      }
    }

    // Update cookie with new selection
    function updateCookie(key, value) {
      const currentSelections = getCookie("car_selections") || {};
      currentSelections[key] = value;
      setCookie("car_selections", currentSelections, 7);
    }

    // Get category handle from name
    function getCategoryHandleByName(categoryName) {
      const categoryElements = sectionElement.querySelectorAll(".category");
      for (let i = 0; i < categoryElements.length; i++) {
        if (categoryElements[i].innerHTML === categoryName) {
          return categoryElements[i].getAttribute("data-category");
        }
      }
      return null;
    }

    // Update the Browse Parts button href
    function updateButtonHref() {
      const selectedModel = sectionElement
        .querySelector(".selected-model")
        .getAttribute("data-selected-model-number");
      const selectedYear =
        sectionElement.querySelector(".selected-year").innerHTML;
      const selectedType =
        sectionElement.querySelector(".selected-type").innerHTML;
      const selectedCategory =
        sectionElement.querySelector(".selected-category").innerHTML;

      if (
        selectedModel !== "Select Model" &&
        selectedYear !== "Select Year" &&
        selectedType !== "Select Parts Type" &&
        selectedCategory !== "Select Category"
      ) {
        const selectedCategoryHandle =
          getCategoryHandleByName(selectedCategory);
        // 1. Simplify the regex to catch any mention of "turbo" (fixes the Turbo/GT2 issue)
            const isTurboYear = /turbo/i.test(selectedYear);
            const cleanSelectedYear = selectedYear
              .replace(/\s*\([^)]*\)\s*/g, "")
              .trim();
            const urlModel = isTurboYear ? `${selectedModel}t` : selectedModel;
            const modelArray = cleanSelectedYear.split("-");
            if (modelArray.length < 2) return; 
            const year1 = modelArray[1].slice(-2);
            const year2 = modelArray[0].slice(2);

            // 2. Use urlModel instead of selectedModel so the 't' is included in the dictionary key

            // 3. Update the redirects object to handle the new 't' keys
            const modelYearRedirects = {
              "911-89-94": { model: "964", start: "89", end: "94" },
              "911-94-98": { model: "993", start: "94", end: "98" },
              "911-99-05": { model: "996", start: "99", end: "05" },
              "911t-99-05": { model: "996t", start: "99", end: "05" }, // <-- ADDED: Catches 1999-2005 (Turbo)
              "911-05-08": { model: "997", start: "05", end: "08" },
              "911-09-11": { model: "997", start: "09", end: "11" },
              "911t-07-09": { model: "997t", start: "07", end: "09" }, // <-- UPDATED: Changed from 911 to 911t
              "911t-10-11": { model: "997t2", start: "10", end: "11" }, // <-- UPDATED: Changed from 911 to 911t
              "911-03-05": { model: "gt31", start: "03", end: "05" },
              "911-07-11": { model: "gt32", start: "07", end: "08" },
              "924-86-88": { model: "924s", start: "86", end: "88" },
              "986-05-08": { model: "987", start: "05", end: "08" },
              "986-09-11": { model: "987", start: "09", end: "11" },
              "92A-11-17": { model: "92a", start: "11", end: "14" },
              "92A-03-06": { model: "9pa", start: "03", end: "06" },
              "92A-07-10": { model: "9pa", start: "07", end: "08" },
              "987C-09-11": { model: "987c2", start: "09", end: "11" },
              "92A-10-14": { model: "970", start: "10", end: "11" },
            };
            const modelYearKey = `${urlModel}-${year2}-${year1}`;
        const resolvedModelYear = modelYearRedirects[modelYearKey] || {
          model: urlModel,
          start: year2,
          end: year1
        };
        const resolvedModel = resolvedModelYear.model;
        const resolvedYear2 = resolvedModelYear.start;
        const resolvedYear1 = resolvedModelYear.end;
        const selectedStartYear = modelArray[0];
        const startCentury = Math.floor(Number(selectedStartYear) / 100) * 100;
        const selectedStartShortYear = Number(selectedStartYear.slice(-2));
        const resolvedEndShortYear = Number(resolvedYear1);
        const resolvedEndYear =
          startCentury +
          resolvedEndShortYear +
          (resolvedEndShortYear < selectedStartShortYear ? 100 : 0);
        const resolvedModelYearHandle = `${resolvedModel}-${resolvedYear2}-${resolvedYear1}`;
        const resolvedYearRange = `${selectedStartYear}-${resolvedEndYear}`;

        // Some product metafield values do not match the public collection handle.
        // Add future filter-only fixes here as: "model-start-end": { model: "metafield-model", year: "metafield-year" }
        const filterValueRedirects = {
          "911t-76-77": { model: "930", year: "1975-77" },
          "964-89-94": { model: "911", year: "1989-94"},
          "993-94-98": { model: "911", year: "1994-98"},
          "996-99-05": { model: "911", year: "1998-05"},
          "997-05-08": { model: "911", year: "2005-08"},
          "997-09-11": { model: "911", year: "2009-12"},
          "997t-07-09": { model: "911", year: "Turbo/GT2 2007-09"},
          "gt31-03-05": { model: "911", year: "GT3 2003-05"},
          "gt32-07-08": { model: "911", year: "GT3 2007-11"},
          "gt32-07-08": { model: "911", year: "GT3 2007-11"},
          "924s-86-88": { model: "924", year: "1986-88" },
          "986-97-04": { model: "Boxster", year: "1997-04" },
          "987-05-08": { model: "Boxster", year: "2005-08" },
          "987-09-11": { model: "Boxster", year: "2009-11" },
          "92a-11-14": { model: "Cayenne", year: "2011-14" },
          "9pa-03-06": { model: "Cayenne", year: "2003-06" },
          "9pa-07-08": { model: "Cayenne", year: "2007-10" },
          "987C-06-08": { model: "Cayman", year: "2006-08" },
          "987c2-09-11": { model: "Cayman", year: "2009-12" },
          "970-10-11": { model: "PANAMERA", year: "2010-14" },
          "996t-99-05": { model: "911", year: "Turbo/GT2 2001-05" },
        };

        const resolvedFilterValues = filterValueRedirects[resolvedModelYearHandle] || {
          model: resolvedModel,
          year: `${selectedStartYear}-${resolvedYear1}`
        };
        const modelHasLetters = /[a-zA-Z]/.test(resolvedFilterValues.model);
        const yearHasLetters = /[a-zA-Z]/.test(resolvedFilterValues.year);

        let modelFilters = `&filter.p.m.custom.car_model=${encodeURIComponent(resolvedFilterValues.model)}`;

        if (modelHasLetters && resolvedFilterValues.model !== resolvedFilterValues.model.toUpperCase()) {
          modelFilters += `&filter.p.m.custom.car_model=${encodeURIComponent(resolvedFilterValues.model.toUpperCase())}`;
        }

        let yearFilters = `&filter.p.m.custom.car_year=${encodeURIComponent(resolvedFilterValues.year)}`;

        if (yearHasLetters && resolvedFilterValues.year !== resolvedFilterValues.year.toUpperCase()) {
          yearFilters += `&filter.p.m.custom.car_year=${encodeURIComponent(resolvedFilterValues.year.toUpperCase())}`;
        }
        const button = sectionElement.querySelector(".custom-button");

        if (!button) return; // Guard against null

        if (selectedType === "Accessory Parts") {
          if (selectedCategoryHandle) {
            const href = `/collections/${resolvedModelYearHandle}-${selectedCategoryHandle}?model=${encodeURIComponent(resolvedModel)}-${encodeURIComponent(resolvedYearRange)}&sort_by=manual&filter.v.price.gte=&filter.v.price.lte=${modelFilters}${yearFilters}`;            
            button.setAttribute("href", href);
            return href;
          }
        } else {
          if (selectedCategoryHandle) {
            const pageHandleRedirects = {
              "924-86-88": "924s-86-88"
            };
            const resolvedPageHandle =
              pageHandleRedirects[resolvedModelYearHandle] || resolvedModelYearHandle;
            const href = `/pages/porsche-parts/${resolvedPageHandle}?category=${selectedCategoryHandle}`;
            button.setAttribute("href", href);
            return href;
          }
        }
      }
      return null;
    }

    // Update button disabled states
    function updateButtonState() {
      const selectedModel =
        sectionElement.querySelector(".selected-model").innerHTML;
      const selectedYear =
        sectionElement.querySelector(".selected-year").innerHTML;
      const selectedType =
        sectionElement.querySelector(".selected-type").innerHTML;
      const selectedCategory =
        sectionElement.querySelector(".selected-category").innerHTML;

      const searchButton = sectionElement.querySelector(".custom-button");
      const resetButton = sectionElement.querySelector(".btn-reset");

      if (!searchButton || !resetButton) return; // Guard against null

      if (
        selectedModel === "Select Model" ||
        selectedYear === "Select Year" ||
        selectedCategory === "Select Category"
      ) {
        searchButton.classList.add("disabled");
      } else {
        searchButton.classList.remove("disabled");
      }

      if (selectedModel === "Select Model") {
        resetButton.classList.add("disabled");
      } else {
        resetButton.classList.remove("disabled");
      }
    }

    // Event listeners
    initializeFromCookie();

    const toggleModel = sectionElement.querySelector(".toggle-model");
    if (toggleModel) {
      toggleModel.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleDropdown(".models");
      });
    }

    const toggleYear = sectionElement.querySelector(".toggle-year");
    if (toggleYear) {
      toggleYear.addEventListener("click", (e) => {
        e.stopPropagation();
        const modelSelected =
          sectionElement.querySelector(".selected-model").innerHTML !==
          "Select Model";
        if (modelSelected) {
          toggleDropdown(".years");
        }
      });
    }

    const toggleType = sectionElement.querySelector(".toggle-type");
    if (toggleType) {
      toggleType.addEventListener("click", (e) => {
        e.stopPropagation();
        const modelSelected =
          sectionElement.querySelector(".selected-model").innerHTML !==
          "Select Model";
        const yearSelected =
          sectionElement.querySelector(".selected-year").innerHTML !==
          "Select Year";
        if (modelSelected && yearSelected) {
          toggleDropdown(".types");
        }
      });
    }

    const toggleCategory = sectionElement.querySelector(".toggle-category");
    if (toggleCategory) {
      toggleCategory.addEventListener("click", (e) => {
        e.stopPropagation();
        const modelSelected =
          sectionElement.querySelector(".selected-model").innerHTML !==
          "Select Model";
        const yearSelected =
          sectionElement.querySelector(".selected-year").innerHTML !==
          "Select Year";
        const typeSelected =
          sectionElement.querySelector(".selected-type").innerHTML !==
          "Select Parts Type";
        if (modelSelected && yearSelected && typeSelected) {
          toggleDropdown(".categories");
        }
      });
    }

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".ctm-unique-banner .custom-select")) {
        sectionElement
          .querySelectorAll(".models, .years, .categories, .types")
          .forEach((el) => {
            el.classList.remove("open");
            el.closest(".custom-select")?.classList.remove("active");
          });
      }
    });

    sectionElement.querySelectorAll(".model").forEach((model) => {
      model.addEventListener("click", (e) => {
        const selectedModel = e.target.innerHTML;
        const selectedModelNumber = e.target.getAttribute("data-model-number");
        sectionElement.querySelector(".selected-model").innerHTML =
          selectedModel;
        sectionElement
          .querySelector(".selected-model")
          .setAttribute("data-selected-model-number", selectedModelNumber);

        filterYears(selectedModel);
        const currentSelections = getCookie("car_selections") || {};
        const typeToKeep = currentSelections.type;
        const categoryToKeep = currentSelections.category;
        updateCookie("model", selectedModel);
        updateCookie("model_number", selectedModelNumber);
        setFirstAvailableYear(selectedModel);
        if (categoryToKeep || typeToKeep) {
          sectionElement.querySelector(".selected-type").innerHTML =
            typeToKeep || "Select Parts Type";
          sectionElement.querySelector(".selected-category").innerHTML =
            categoryToKeep || "Select Category";
        }
        updateButtonState();
      });
    });

    sectionElement.querySelectorAll(".year").forEach((year) => {
      year.addEventListener("click", (e) => {
        const selectedYear = e.target.innerHTML;
        sectionElement.querySelector(".selected-year").innerHTML = selectedYear;
        updateCookie("year", selectedYear);
        const currentSelections = getCookie("car_selections") || {};
        if (currentSelections.category) {
          updateButtonHref();
        }
        updateButtonState();
      });
    });

    sectionElement.querySelectorAll(".type").forEach((type) => {
      type.addEventListener("click", (e) => {
        const selectedType = e.target.innerHTML;
        sectionElement.querySelector(".selected-type").innerHTML = selectedType;
        updateCookie("type", selectedType);
        const currentSelections = getCookie("car_selections") || {};
        if (currentSelections.type) {
          updateButtonHref();
        }
        updateButtonState();
      });
    });

    sectionElement.querySelectorAll(".category").forEach((category) => {
      category.addEventListener("click", (e) => {
        const selectedCategory = e.target.innerHTML;
        sectionElement.querySelector(".selected-category").innerHTML =
          selectedCategory;
        updateCookie("category", selectedCategory);
        updateButtonHref();
        updateButtonState();
      });
    });

    const resetButton = sectionElement.querySelector(".btn-reset");
    if (resetButton) {
      resetButton.addEventListener("click", (e) => {
        e.preventDefault();
        deleteCookie("car_selections");
        sectionElement.querySelector(".selected-model").innerHTML =
          "Select Model";
        sectionElement.querySelector(".selected-year").innerHTML =
          "Select Year";
        sectionElement.querySelector(".selected-type").innerHTML =
          "Select Parts Type";
        sectionElement.querySelector(".selected-category").innerHTML =
          "Select Category";
        sectionElement.querySelector(".custom-button").removeAttribute("href");
        sectionElement.querySelectorAll(".years .year").forEach((year) => {
          year.style.display = "block";
        });
        updateButtonState();
      });
    }

    document.addEventListener("externalModelSelected", (e) => {
      const { model } = e.detail;
      if (model && sectionElement.querySelector(".selected-model")) {
        sectionElement.querySelector(".selected-model").innerHTML = model;
        filterYears(model);
        updateCookie("model", model);
        setFirstAvailableYear(model);
        const currentSelections = getCookie("car_selections") || {};
        if (currentSelections.category) {
          updateButtonHref();
        }
        updateButtonState();
      }
    });
  });
});

// Log cookie state globally
console.log("Current car_selections cookie:", getCookie("car_selections"));
